(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chefmel-booking-flow"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.getElementById('chefmel-booking-flow-config');
  if (!config || config.dataset.initialized) return;
  config.dataset.initialized = 'true';
  const text = config.dataset;
  const addSelector = '[data-servicify="servicify-add-to-cart-button"]';
  const handled = new WeakSet();
  let mode = null;
  let buyTrigger = false;
  let queued = false;
  const validate = (button) => {
    const modal = button.closest('.ReactModal__Content');
    if (!modal) return false;
    for (const field of modal.querySelectorAll('[data-servicify="custom-field-input"]')) {
      if (!field.checkValidity()) { field.reportValidity(); return false; }
    }
    return true;
  };
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest(addSelector);
    if (button) {
      if (button.disabled || !validate(button)) { event.preventDefault(); event.stopImmediatePropagation(); return; }
      if (!buyTrigger) mode = 'cart';
    }
    if (event.target.closest('.servicify-modal-close')) mode = null;
  }, true);
  const enhance = () => {
    queued = false;
    for (const button of document.querySelectorAll(addSelector)) {
      const actions = button.parentElement;
      if (!actions) continue;
      actions.classList.add('mel-booking-actions');
      let buy = actions.querySelector('.mel-booking-buy-now');
      if (!buy) {
        buy = document.createElement('button');
        buy.type = 'button';
        buy.className = 'mel-booking-buy-now';
        buy.textContent = text.buyNow;
        buy.addEventListener('click', () => {
          if (button.disabled || !validate(button)) return;
          mode = 'buy';
          buyTrigger = true;
          button.click();
          buyTrigger = false;
        });
        actions.append(buy);
      }
      if (buy.disabled !== button.disabled) buy.disabled = button.disabled;
      const modal = button.closest('.ReactModal__Content');
      if (!modal) continue;
      for (const field of modal.querySelectorAll('[data-servicify="custom-field-input"]')) {
        const name = field.getAttribute('name') || '';
        if (name === 'properties[Email address]' && field.type !== 'email') { field.type = 'email'; field.autocomplete = 'email'; }
        if (name === 'properties[Contact number]' && field.type !== 'tel') { field.type = 'tel'; field.autocomplete = 'tel'; }
        if (name === 'properties[Full name]') field.autocomplete = 'name';
      }
      const attendees = modal.querySelector('[data-servicify="number-attending-container"]');
      const input = attendees?.querySelector('input');
      if (input) {
        input.setAttribute('aria-label', text.attendees);
        input.inputMode = 'numeric';
        for (const control of [input.previousElementSibling, input.nextElementSibling]) {
          if (!control || control.dataset.melEnhanced) continue;
          control.dataset.melEnhanced = 'true';
          control.setAttribute('role', 'button');
          control.tabIndex = 0;
          control.setAttribute('aria-label', control.textContent.trim() === '+' ? text.increase : text.decrease);
          control.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); control.click(); }
          });
        }
        if (!attendees.querySelector('.mel-booking-seat-note')) {
          const note = document.createElement('p');
          note.className = 'mel-booking-seat-note';
          note.textContent = text.seatNote;
          attendees.append(note);
        }
      }
    }
    for (const summary of document.querySelectorAll('.servicify-confirmation [data-servicify="added-to-cart"]')) {
      if (!mode || handled.has(summary)) continue;
      handled.add(summary);
      const selectedMode = mode;
      mode = null;
      const modal = summary.closest('.ReactModal__Content');
      const checkout = modal?.querySelector('[data-servicify="checkout"]');
      if (selectedMode === 'buy') {
        if (checkout) checkout.click();
        continue;
      }
      const title = modal?.querySelector('[data-servicify="checkout-required"]');
      if (title) title.textContent = text.added;
      const subtitle = modal?.querySelector('.servicify-confirmation-subtitle');
      if (subtitle) subtitle.textContent = text.pending;
      modal?.querySelector('.servicify-modal-close')?.click();
      setTimeout(() => document.dispatchEvent(new CustomEvent('cart:add')), 350);
    }
  };
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(enhance);
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
  enhance();
  window.addEventListener('pagehide', () => observer.disconnect(), { once: true });
})();
  } catch(e) { console.error(e); }
})();

})();
